.root {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.head {
  align-items: flex-start;
  display: flex;
  gap: 12px;
  justify-content: space-between;
}

.head-text {
  align-items: flex-start;
  display: flex;
  gap: 10px;
  min-width: 0;
}

/* Visible source label — the section's origin must not be carried by colour
   alone, the same rule the supplier documents section follows. */
.badge {
  background: var(--color-background-info, #e5f2ff);
  border-radius: 6px;
  color: var(--color-text-info, #339cff);
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  white-space: nowrap;
}

.title {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 2px;
}

.crm-link {
  align-items: center;
  background: var(--color-surface, #fff);
  border: 1px solid var(--color-border, #d4d7dd);
  border-radius: 8px;
  color: var(--color-text, #17191d);
  display: inline-flex;
  flex-shrink: 0;
  font-size: 13px;
  gap: 6px;
  padding: 7px 12px;
  text-decoration: none;

  &:hover {
    background: var(--color-surface-hover, #f6f7f8);
  }
}

.fields {
  background: var(--color-surface, #fff);
  border: 1px solid var(--color-border, #e2e4e9);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin: 0;
  padding: 16px 18px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.label {
  color: var(--color-text-muted, #535862);
  font-size: 12px;
  font-weight: 600;
}

.value {
  color: var(--color-text, #17191d);
  font-size: 14px;
  line-height: 1.7;
  margin: 0;
}

.notes {
  p {
    margin: 0 0 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ul,
  ol {
    margin: 0 0 10px;
    padding-left: 20px;
  }

  a {
    color: var(--color-primary, #2563eb);
  }
}

/* Plain-text supplier notes: the source newlines ARE the formatting. */
.notes-plain {
  white-space: pre-line;
}

@media (max-width: 720px) {
  .head {
    flex-direction: column;
  }
}
